import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// Fallback for browsers/preview iframes that block third-party cookies:
// the login response also returns an access token, stored and sent as a Bearer header.
const TOKEN_KEY = "sp_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const mediaUrl = (path) => (path ? `${API}/media/${path}` : "");

// Fast web-optimized thumbnail served by the backend (generated on upload or on demand).
// Falls back to the original file automatically for non-image media.
export const thumbUrl = (media) => {
  if (!media) return "";
  const path = media.thumb_path || media.storage_path || "";
  if (!path) return "";
  return media.media_type === "image" ? `${API}/media/${path}?thumb=1` : mediaUrl(path);
};

export const coverUrl = (cat) => {
  const path = cat?.cover_path || "";
  return path ? `${API}/media/${path}?thumb=1` : "";
};

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
